import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, finalize, map, tap } from 'rxjs';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { LanguagesService } from '../languages/services/languages.service';
import { StartupConfigService } from 'projects/config/startup-config.service';

export enum TranslocoTermsStatus {
  PENDING,
  LOADED,
}

@Injectable({
  providedIn: 'root',
})
export class TranslocoApiLoader implements TranslocoLoader {
  private _termsStatus$ = new BehaviorSubject(TranslocoTermsStatus.PENDING);
  public termsStatus$ = this._termsStatus$.asObservable();

  /**
   * Constructor
   */
  constructor(
    private _languagesService: LanguagesService,
    private _startupConfigService: StartupConfigService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  reset(): void {
    this._termsStatus$.next(TranslocoTermsStatus.PENDING);
  }

  getTranslation(lang: string): Observable<Translation> {
    const response = this._languagesService.getTerms(lang);
    return response.pipe(
      map((res) =>
        res.reduce((terms, term) => {
          terms[term.tn] = term.tv;
          return terms;
        }, {})
      ),
      finalize(() => {
        this._termsStatus$.next(TranslocoTermsStatus.LOADED);
        this._startupConfigService.initialized();
      })
    );
  }
}
